// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-USQ","option":"styles_option__SJkO5","selected":"styles_selected__3WTLg"};